var _g, _path, _path2, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMfluxLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 158 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#34528C"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    width: 11.5,
    height: 8.4,
    rx: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 5,
    width: 11.5,
    height: 8.4,
    rx: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 22.2,
    width: 11.5,
    height: 8.4,
    rx: 2.7
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.2 H23.5",
    stroke: "#34528C",
    strokeWidth: 3.4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 13.4 L18.5 22.2",
    stroke: "#34528C",
    strokeWidth: 3.4,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 46,
    y: 28,
    fontFamily: "Inter, 'Segoe UI', Arial, sans-serif",
    fontSize: 23,
    fontWeight: 800,
    letterSpacing: -0.5,
    fill: "#22304d"
  }, "MFlux")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMfluxLogo);
export default __webpack_public_path__ + "static/media/mflux-logo.c3f8306a394edfbc3cb67f55becaec12.svg";
export { ForwardRef as ReactComponent };